import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { withTranslation, WithTranslation } from 'react-i18next';
import { clsx } from '../utils/htmlUtils';

/**
 * A component to render a global loading spinner before displaying some data on a page
 */

interface HistoryProps extends WithTranslation {
    header?: JSX.Element;
    datas: JSX.Element[];
    customEmpty?: JSX.Element;
    nbColumns?: number;
}

const Listing = (props: HistoryProps): JSX.Element => {
    const classes = useTabStyles({ nbColumns: props.nbColumns });
    const { t, datas, header, customEmpty, nbColumns } = props;

    return (
        <div>
            {datas && header}
            <div className={clsx(classes.rootListing, nbColumns > 1 && classes.columns)}>
                {datas &&
                    datas.map((element, index) => {
                        return (
                            <div key={index} className={classes.row}>
                                {element}
                            </div>
                        );
                    })}
                {(!datas || datas.length < 1) &&
                    (customEmpty ? (
                        customEmpty
                    ) : (
                        <div className={clsx(classes.row, classes.center)}>{t('listing.empty_add')}</div>
                    ))}
            </div>
        </div>
    );
};

const useTabStyles = makeStyles((theme: Theme) =>
    createStyles({
        rootListing: {},
        columns: {
            display: 'flex',
            flexWrap: 'wrap',
            '& > div': {
                flex: (props: { nbColumns?: number }) => `1 1 ${100 / props.nbColumns}%`,
                boxSizing: 'border-box',
                padding: 10,
            },
        },
        row: {
            display: 'flex',
            flex: 1,
            background: theme.palette.colors.white,
            padding: 20,
            '&:nth-of-type(odd)': {
                backgroundColor: theme.palette.colors.table.hover,
                borderTop: `1px solid ${theme.palette.colors.table.separator}`,
                borderBottom: `1px solid ${theme.palette.colors.table.separator}`,
            },
        },
        center: {
            justifyContent: 'center',
        },
    }),
);

export default withTranslation(['common'])(Listing);
